import { Component } from '@angular/core';
import { NavController, NavParams, Platform } from 'ionic-angular';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
	selector: 'page-conference',
	templateUrl: 'conference.html',
})

export class ConferencePage {

	displayData: boolean = false;
	fileList: Array<{ client:string, filename: string, }>;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
		private file: File,
		private platform: Platform,
		private fileOpener: FileOpener,
		private iab: InAppBrowser) {
	}

	ionViewDidLoad() {
		this.fileList = [
			{ client: 'Children’s Hearings Scotland', filename: 'Childrens_Health_Scotland' },
			{ client: 'St Andrews University', filename: 'StAN' },
			{ client: 'OGICA', filename: 'OGICA' }			
		];

		this.displayData = true;
	}

	openFile(filename) {

		let fullFileName = filename  + '.pdf';
		if(!this.platform.is('ios')) 
		{
			window.open("assets/case-studies/" + fullFileName, '_blank');
		}	
		else{
			this.file.checkFile(this.file.externalApplicationStorageDirectory, fullFileName).then((result: boolean) => {

				this.fileOpener.open(this.file.externalApplicationStorageDirectory + fullFileName, 'application/pdf').then( () => 
					console.log('File is opened')
				).catch( e => 
					console.log('Error openening file', e)
				);
	
			}).catch((err) => {
				this.file.copyFile(this.file.applicationDirectory + 'www/assets/case-studies/', fullFileName, this.file.externalApplicationStorageDirectory, fullFileName).then( result => {
					this.fileOpener.open(this.file.externalApplicationStorageDirectory + fullFileName, 'application/pdf').then( () => 
						console.log('File is opened')
					).catch( e => 
						console.log('Error openening file', e)
					);
				}, err => {
					console.log("Error");
					console.log(err);
				});
	
			});
		}
	}

	openFileInBrowser(filename){
		this.iab.create('assets/case-studies/' + filename + '.pdf', '_system');
	}

	openURL(url){
		this.iab.create(url, '_system');
	}

}



// WEBPACK FOOTER //
// ./src/pages/conference/conference.ts